import { useCompanyAuthStore } from "store/companyAuth";

export default function companyAuthHeader() {
  const token = useCompanyAuthStore.getState().getToken();

  if (token) {
    return {"x-auth-token": token};
  } else {
    return {};
  }
}

